import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBarChartFilled = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M2 13.6667C2 13.0467 2 12.7367 2.06815 12.4824C2.25308 11.7922 2.79218 11.2531 3.48236 11.0681C3.7367 11 4.04669 11 4.66667 11C5.28665 11 5.59664 11 5.85097 11.0681C6.54116 11.2531 7.08025 11.7922 7.26519 12.4824C7.33333 12.7367 7.33333 13.0467 7.33333 13.6667V20.4C7.33333 20.9601 7.33333 21.2401 7.22434 21.454C7.12847 21.6422 6.97549 21.7951 6.78732 21.891C6.57341 22 6.29339 22 5.73333 22H5.2C4.0799 22 3.51984 22 3.09202 21.782C2.71569 21.5903 2.40973 21.2843 2.21799 20.908C2 20.4802 2 19.9201 2 18.8V13.6667Z",
			fill: "#2563EB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.33331 4.66667C9.33331 4.04669 9.33331 3.7367 9.40146 3.48236C9.5864 2.79218 10.1255 2.25308 10.8157 2.06815C11.07 2 11.38 2 12 2C12.62 2 12.93 2 13.1843 2.06815C13.8745 2.25308 14.4136 2.79218 14.5985 3.48236C14.6666 3.7367 14.6666 4.04669 14.6666 4.66667V20.4C14.6666 20.9601 14.6666 21.2401 14.5577 21.454C14.4618 21.6422 14.3088 21.7951 14.1206 21.891C13.9067 22 13.6267 22 13.0666 22H10.9333C10.3733 22 10.0932 22 9.87932 21.891C9.69116 21.7951 9.53818 21.6422 9.44231 21.454C9.33331 21.2401 9.33331 20.9601 9.33331 20.4V4.66667Z",
			fill: "#2563EB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.6667 9.66667C16.6667 9.04669 16.6667 8.7367 16.7348 8.48236C16.9198 7.79218 17.4589 7.25308 18.149 7.06815C18.4034 7 18.7134 7 19.3334 7C19.9533 7 20.2633 7 20.5177 7.06815C21.2078 7.25308 21.7469 7.79218 21.9319 8.48236C22 8.7367 22 9.04669 22 9.66667V18.8C22 19.9201 22 20.4802 21.782 20.908C21.5903 21.2843 21.2843 21.5903 20.908 21.782C20.4802 22 19.9201 22 18.8 22H18.2667C17.7066 22 17.4266 22 17.2127 21.891C17.0245 21.7951 16.8716 21.6422 16.7757 21.454C16.6667 21.2401 16.6667 20.9601 16.6667 20.4V9.66667Z",
			fill: "#2563EB"
		})
	]
});
const ForwardRef = forwardRef(SvgBarChartFilled);
export default ForwardRef;
